import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Attachment02Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {acceptedFileTypes} from '@/features/users/utils'
import {FileUploader} from '@/components/commons/file-upload/FileUpload'
import {useFormContext, useWatch} from 'react-hook-form'
import {useDeleteDocument} from '@/services/useDeleteDocument'
import {useUploadDocument} from '@/services/useUploadDocument'
import {toast} from '@/utilities/toast/toast'

export const AslSecondAttachment = () => {
    const {t} = useTranslation()

    const {control, setValue} = useFormContext()

    const document = useWatch({control, name: 'aslSecondAttachment'})

    const uploadDocument = useUploadDocument({
        onSuccess: response => {
            setValue('aslSecondAttachment', response, {shouldDirty: true})
            toast.success(t('commons:upload_success'))
        },
        onError: () => toast.error(t('commons:upload_error'))
    })
    const deleteDocument = useDeleteDocument({
        onSuccess: () => {
            setValue('aslSecondAttachment', null, {shouldDirty: true})
        }
    })

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Flexbox gap={1}>
                <Text palette="neutral" shade="950" size="textSm" weight="500">
                    {t('projects:asl_authorization')}
                </Text>
                <Text palette="neutral" shade="500" size="textSm" weight="400">
                    {t('projects:attachment_x', {count: 2})}
                </Text>
            </Flexbox>
            <FileUploader
                document={document}
                isLoading={uploadDocument.isPending || deleteDocument.isPending}
                inputFileProps={{
                    acceptedFiles: acceptedFileTypes,
                    maxSizeInMB: 8,
                    placeholder: t('projects:attach_file'),
                    onAcceptFiles: file => {
                        const formData = new FormData()
                        formData.append(`file`, file)
                        uploadDocument.mutate(formData)
                    },
                    typeIcon: <Attachment02Icon size={15} />,
                    hideButton: true,
                    width: '100%'
                }}
                onDeleteFile={deleteDocument.mutate}
                dropDownMenuProps={{
                    triggerWidth: '100%'
                }}
            />
        </Flexbox>
    )
}
